if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      static countryData;

      constructor() {
        super();
        this.mql = window.matchMedia('(min-width: 750px)');
        this.header = document.querySelector('.header-wrapper');
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button.localization-form__select'),
          panel: this.querySelector('.disclosure__list-wrapper'),
          search: this.querySelector('input[name="country_filter"]'),
          closeButton: this.querySelector('.country-selector__close-button'),
          resetButton: this.querySelector('.country-filter__reset-button'),
          searchIcon: this.querySelector('.country-filter__search-icon'),
          liveRegion: this.querySelector('[data-country-search-results]'),
        };
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
        this.addEventListener('keydown', this.onContainerKeyDown.bind(this));
        this.addEventListener('focusout', this.closeSelector.bind(this));
        this.elements.button.addEventListener('click', this.openSelector.bind(this));

        if (this.elements.search) {
          this.elements.search.addEventListener('input', this.filterCountries.bind(this));
          this.elements.search.addEventListener('focus', this.onSearchFocus.bind(this));
          this.elements.search.addEventListener('blur', this.onSearchBlur.bind(this));
          this.elements.search.addEventListener('keydown', this.onSearchKeyDown.bind(this));
        }
        if (this.elements.closeButton) {
          this.elements.closeButton.addEventListener('click', this.hidePanel.bind(this));
        }
        if (this.elements.resetButton) {
          this.elements.resetButton.addEventListener('click', this.resetFilter.bind(this));
          this.elements.resetButton.addEventListener('mousedown', (event) => event.preventDefault());
        }

        this.addEventListener('click', (event) => {
          const item = event.target.closest('a[data-value]');
          if (item && this.contains(item)) this.onItemClick(event, item);
        });
      }

      ensureCountryOptions() {
        const container = this.querySelector('[data-country-options]');
        if (!container || this.countryOptionsReady) return true;

        const source = document.getElementById('CountryLocalizationData');
        const template = document.getElementById('CountryLocalizationOption');
        if (!source || !template) return false;
        if (!this.constructor.countryData) {
          const data = JSON.parse(source.textContent);
          // Shopify labels can contain HTML entities. Decode in a detached text
          // context, then use textContent below so labels never become markup.
          const decoder = document.createElement('textarea');
          const decodeLabel = (value) => {
            decoder.innerHTML = String(value ?? '').replace(/</g, '&lt;');
            return decoder.value;
          };
          data.countries = data.countries.map(([code, name, currency, symbol]) => [
            code, decodeLabel(name), currency, decodeLabel(symbol),
          ]);
          this.constructor.countryData = data;
        }
        const data = this.constructor.countryData;
        const countries = new Map(data.countries.map((country) => [country[0], country]));

        container.querySelectorAll('[data-country-list]').forEach((list) => {
          const isPopular = list.dataset.countryList === 'popular';
          const entries = isPopular ? data.popular.map((code) => countries.get(code)).filter(Boolean) : data.countries;
          const fragment = document.createDocumentFragment();
          entries.forEach(([code, name, currency, symbol]) => {
            const option = template.content.firstElementChild.cloneNode(true);
            const link = option.querySelector('a');
            const isCurrent = code === this.elements.input.value;
            link.dataset.value = code;
            link.id = `${container.dataset.countryOptions}-${isPopular ? 'popular-' : ''}country-${code}`;
            if (isCurrent) link.setAttribute('aria-current', 'true');
            option.querySelector('[data-country-check]').classList.toggle('visibility-hidden', !isCurrent);
            option.querySelector('.country').textContent = name;
            const currencyLabel = option.querySelector('.localization-form__currency');
            currencyLabel.textContent = `${currency} ${symbol}`;
            currencyLabel.classList.toggle('hidden', container.dataset.showCurrencies !== 'true');
            fragment.appendChild(option);
          });
          list.appendChild(fragment);
        });
        this.countryOptionsReady = true;
        return true;
      }

      hidePanel() {
        if (this.elements.panel.hidden) return;
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
        if (this.elements.search) {
          this.elements.search.value = '';
          this.filterCountries();
        }
        document.body.classList.remove('overflow-hidden-mobile');
        document.querySelector('.menu-drawer')?.classList.remove('country-selector-open');
        if (this.header) this.header.preventHide = false;
      }

      onContainerKeyDown(event) {
        if (this.elements.panel.hidden) return;
        const focusableItems = Array.from(this.querySelectorAll('a')).filter(
          (item) => !item.closest('.hidden, [hidden]')
        );
        if (!focusableItems.length) return;
        let focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
        let itemToFocus;

        switch (event.code.toUpperCase()) {
          case 'ARROWUP':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex > 0 ? focusableItems[focusedItemIndex - 1] : focusableItems[focusableItems.length - 1];
            itemToFocus.focus();
            break;
          case 'ARROWDOWN':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex < focusableItems.length - 1 ? focusableItems[focusedItemIndex + 1] : focusableItems[0];
            itemToFocus.focus();
            break;
        }

      }

      onContainerKeyUp(event) {
        switch (event.code.toUpperCase()) {
          case 'ESCAPE':
            if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
            this.hidePanel();
            event.stopPropagation();
            this.elements.button.focus();
            break;
        }
      }

      onItemClick(event, item) {
        event.preventDefault();
        const form = this.querySelector('form');
        this.elements.input.value = item.dataset.value;
        if (form) form.submit();
      }

      openSelector() {
        if (!this.elements.panel.hidden) {
          this.hidePanel();
          return;
        }
        if (!this.ensureCountryOptions()) return;
        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute(
          'aria-expanded',
          (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
        );
        if (!document.body.classList.contains('overflow-hidden-tablet')) {
          document.body.classList.add('overflow-hidden-mobile');
        }
        if (this.elements.search && this.mql.matches) {
          this.elements.search.focus();
        }
        if (this.hasAttribute('data-prevent-hide') && this.header) {
          this.header.preventHide = true;
        }
        document.querySelector('.menu-drawer')?.classList.add('country-selector-open');
      }

      closeSelector(event) {
        if (
          event.target.classList.contains('country-selector__overlay') ||
          !this.contains(event.target) ||
          !this.contains(event.relatedTarget)
        ) {
          this.hidePanel();
        }
      }

      normalizeString(str) {
        return str
          .normalize('NFD')
          .replace(/\p{Diacritic}/gu, '')
          .toLowerCase();
      }

      filterCountries() {
        const searchValue = this.normalizeString(this.elements.search.value);
        const popularCountries = this.querySelector('.popular-countries');
        const allCountries = this.querySelectorAll('a');
        const visibleCountries = new Set();

        this.elements.resetButton.classList.toggle('hidden', !searchValue);

        if (popularCountries) {
          popularCountries.classList.toggle('hidden', searchValue);
        }

        allCountries.forEach((item) => {
          const countryName = this.normalizeString(item.querySelector('.country').textContent);
          if (countryName.indexOf(searchValue) > -1) {
            item.parentElement.classList.remove('hidden');
            visibleCountries.add(item.dataset.value);
          } else {
            item.parentElement.classList.add('hidden');
          }
        });

        if (this.elements.liveRegion) {
          this.elements.liveRegion.textContent = window.accessibilityStrings.countrySelectorSearchCount.replace(
            '[count]',
            visibleCountries.size
          );
        }

        this.querySelector('.country-selector').scrollTop = 0;
        this.querySelector('.country-selector__list').scrollTop = 0;
      }

      resetFilter(event) {
        event.stopPropagation();
        this.elements.search.value = '';
        this.filterCountries();
        this.elements.search.focus();
      }

      onSearchFocus() {
        this.elements.searchIcon.classList.add('country-filter__search-icon--hidden');
      }

      onSearchBlur() {
        if (!this.elements.search.value) {
          this.elements.searchIcon.classList.remove('country-filter__search-icon--hidden');
        }
      }

      onSearchKeyDown(event) {
        if (event.code.toUpperCase() === 'ENTER') {
          event.preventDefault();
        }
      }
    }
  );
}
